import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const RouteProtection = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Force username setup for authenticated users without username
  useEffect(() => {
    if (!loading && user && !user.username) {
      const currentPath = location.pathname;
      const isDevRoute = currentPath.startsWith('/dev/');
      const isUsernameSetup = currentPath === '/username-setup';
      
      // Don't redirect if already on username setup or dev routes
      if (!isUsernameSetup && !isDevRoute) {
        navigate('/username-setup', { replace: true });
      }
    }
  }, [loading, user, location.pathname, navigate]);

  // This component doesn't render anything
  return null;
};

export default RouteProtection;